import createIcon from '../../createIcon';

/**
 * @component @name ProductionQuantityLimits
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMTAuNUgxMlY4LjVIMTRWMTAuNVpNMTQgNi41SDEyVjEuNUgxNFY2LjVaTTggMTguNUM2LjkgMTguNSA2LjAxIDE5LjQgNi4wMSAyMC41QzYuMDEgMjEuNiA2LjkgMjIuNSA4IDIyLjVDOS4xIDIyLjUgMTAgMjEuNiAxMCAyMC41QzEwIDE5LjQgOS4xIDE4LjUgOCAxOC41Wk0xOCAxOC41QzE2LjkgMTguNSAxNi4wMSAxOS40IDE2LjAxIDIwLjVDMTYuMDEgMjEuNiAxNi45IDIyLjUgMTggMjIuNUMxOS4xIDIyLjUgMjAgMjEuNiAyMCAyMC41QzIwIDE5LjQgMTkuMSAxOC41IDE4IDE4LjVaTTkuMSAxMy41SDE2LjU1QzE3LjMgMTMuNSAxNy45NiAxMy4wOSAxOC4zIDEyLjQ3TDIyIDUuNDZMMjAuMjUgNC41TDE2LjU1IDExLjVIOS41M0w1LjI3IDIuNUgyVjQuNUg0TDcuNiAxMi4wOUw2LjI1IDE0LjUzQzUuNTIgMTUuODcgNi40OCAxNy41IDggMTcuNUgyMFYxNS41SDhMOS4xIDEzLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ProductionQuantityLimits = createIcon('ProductionQuantityLimits', [
  [
    'path',
    {
      d: 'M14 10.5H12V8.5H14V10.5ZM14 6.5H12V1.5H14V6.5ZM8 18.5C6.9 18.5 6.01 19.4 6.01 20.5C6.01 21.6 6.9 22.5 8 22.5C9.1 22.5 10 21.6 10 20.5C10 19.4 9.1 18.5 8 18.5ZM18 18.5C16.9 18.5 16.01 19.4 16.01 20.5C16.01 21.6 16.9 22.5 18 22.5C19.1 22.5 20 21.6 20 20.5C20 19.4 19.1 18.5 18 18.5ZM9.1 13.5H16.55C17.3 13.5 17.96 13.09 18.3 12.47L22 5.46L20.25 4.5L16.55 11.5H9.53L5.27 2.5H2V4.5H4L7.6 12.09L6.25 14.53C5.52 15.87 6.48 17.5 8 17.5H20V15.5H8L9.1 13.5Z',
      key: 'cs22wf',
    },
  ],
]);

export default ProductionQuantityLimits;
